"use client";

import React, { lazy, Suspense, useState, useEffect } from "react";
import { getWorkOrders } from "../../components/http";
import { useTranslation } from "react-i18next";
import styles from "../../components/TableTemplate/TableTemplate.module.scss";
import dayjs from "dayjs"; 
import style from "./WorkOrdersPage.module.scss";
import useNavigator from "../../components/navigator/navigator";

const Header = lazy(() => import("../../components/header/header"));
const TableTemplate = lazy(() => import("../../components/TableTemplate/TableTemplate"));
const Pagination = lazy(() => import("../../components/Pagination/Pagination"));

const WorkOrdersPage = () => {
  const { t } = useTranslation();
  const [workOrders, setWorkOrders] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const limit = 5;

  const fetchWorkOrders = async (page) => {
    setIsLoading(true);
    try {
      const offset = (page - 1) * limit;
      const response = await getWorkOrders(limit, offset);
      setWorkOrders(response.data || []);
      setTotalRecords(response.total_count || 0);
    } catch (error) {
      console.error(t("workOrder.list.errors.fetching"), error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkOrders(currentPage);
  }, [currentPage]);

  const headers = [
    t("workOrder.list.clientName"),
    t("workOrder.list.carDetails"),
    t("workOrder.list.start"),
    t("workOrder.list.end"),
  ];
  
  const navigate = useNavigator(); 

  const renderRow = (order) => {
    const { car } = order;
    return (
      <>
        <div data-label={headers[0]} onClick={() => navigate(`/clients/client/${order.client.id}`)} className={style.hyperLink}>
          {order.client?.fullname || t("workOrder.list.noClient")}
        </div>
        <div data-label={headers[1]} onClick={() => navigate(`/cars/${order.car.id}`)} className={style.hyperLink}>
          {car 
            ? `${car.manufacturer} ${car.model} (${car.reg_number})` 
            : t("workOrder.list.noCarDetails")}
        </div>
        <div className={styles.cell} data-label={headers[2]}>
          {order.start_at ? dayjs(order.start_at).format('DD/MM/YYYY') : "N/A"}
        </div>
        <div className={styles.cell} data-label={headers[3]}>
          {order.end_at ? dayjs(order.end_at).format('DD/MM/YYYY') : "N/A"}
        </div>
      </>
    );
  };

  return (
    <Suspense fallback={<div>{t("loading")}</div>}>
      <Header
        title={t("workOrder.list.title")}
        onAddClick={() => navigate(`/workOrders/add`)}
        showImportExport={false}
      />
      <TableTemplate headers={headers} data={workOrders} renderRow={renderRow} isLoading={isLoading} path="/workOrders" />
      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(totalRecords / limit)}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </Suspense>
  );
};

export default WorkOrdersPage;
